/*eslint-disable */
const $ = window.jQuery = require('jquery');  
import toast from '@/services/toast';
import { Datetime } from 'vue-datetime';
import { VueEditor } from "vue2-editor";
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
export default {
  name: 'emplooye-task-add',
  components: {
    datetime: Datetime,
    VueEditor
  },
  props: [],
  data () {
    return {
      submitted:false,
      title:'',
      content:'',
      start_date:'',
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold','italic','link',  '|', 'heading', 'fontFamily','fontSize','undo','redo']
      },
      editorData: '',
    }
  },
  computed: {

  },
  mounted () {
  },
  methods: {
    validateTaskBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
            let data = {
              title:this.title,
              content:this.content,
              start_date:this.start_date
            }
            this.$store.dispatch('createEmployeeTaskFun', data)
              .then((res) => {  
                  toast.success(res.data.msg);           
                  this.submitted = false;
                  this.$router.push({ name: 'employeeTaskList'})
              }).catch((err) => {        
                this.submitted = false;
                toast.error(err.data.user_msg || err.data.msg);
              })
            return;
        }
      });
    }
  }
}